<template>
  <div
    class="pay-refund-bd tb"
    v-if="funcView.pay_fefund_list"
  >
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item
          style="float: right; margin-right: 0"
          v-if="funcView.pay_refund_export"
        >
          <el-button
            class="table-set"
            style="vertical-align: top"
            @click="exportTable('billPayRefundExport', formSearch)"
          ><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <el-form-item
          style="float: right"
          :style="{ marginRight: !funcView.pay_refund_export ? '0' : '' }"
        >
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            :placeholder="$t('fms_pay_refund.htddbh')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <el-form-item :label="$t('fms_pay_refund.he_tong_bian_hao')">
          <el-input
            v-model="formSearch.contractNo"
            style="width:100%;"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_pay_refund.jiao_yi_zhuang_tai')">
          <custom-select
            v-model="formSearch.billTradeState"
            code="bill_trade_state"
            :multiple="true"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('fms_pay_refund.ji_shen_hao')">
          <el-input
            v-model="formSearch.bodyNum"
            style="width:100%;"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_pay_refund.shou_kuan_ri_qi')">
          <custom-date-picker
            v-model="formSearch.dateTime1"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('fms_pay_refund.tui_kuan_ri_qi')">
          <custom-date-picker
            v-model="formSearch.dateTime2"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        ref="table"
        height="100%"
        type="checkbox"
        tableCode="pay_refund"
        v-model="tableSelect"
        :data="tableList"
        @sort="sortChange"
        @filter="filterChange"
        @column="setColumn"
        :slots="['contractDetail', 'termUseTime', 'deviceInfo', 'totalTerm', 'action']"
      >
        <template
          slot="termUseTime"
          slot-scope="scope"
        >
          <div>{{ scope.row.termUseTime }}{{ getDicValue('rental_term_unit', scope.row.rentalTermUnit) }}</div>
        </template>
        <template
          slot="totalTerm"
          slot-scope="scope"
        >
          <div>{{ scope.row.termNum }}/{{ scope.row.totalTerm }}</div>
        </template>
        <template
          slot="contractDetail"
          slot-scope="scope"
        >
          <div>{{ $t('fms_pay_refund.xiang_mu') }}：{{ scope.row.locationName }}</div>
          <div>{{ $t('fms_pay_refund.he_tong_lei_xing') }}：{{ getDicValue('crm_contract_type', scope.row.orderType) }}</div>
          <div>{{ $t('fms_pay_refund.he_tong_bian_hao') }}：{{ scope.row.contractNo }}</div>
          <div>{{ $t('fms_pay_refund.ding_dan_bian_hao') }}：{{ scope.row.orderCode }}</div>
          <div>{{ $t('fms_pay_refund.he_tong_zhuang_tai') }}：{{ getDicValue('crm_contract_biz_state', scope.row.orderState) }}</div>
        </template>
        <template
          slot="deviceInfo"
          slot-scope="scope"
        >
          <div>{{ $t('fms_pay_refund.xing_hao') }}：{{ scope.row.productCode }}</div>
          <div>{{ $t('fms_pay_refund.ji_shen_hao') }}：{{ scope.row.bodyNum }}</div>
          <div>{{ $t('fms_pay_refund.she_bei_lei_xing') }}：{{ scope.row.deviceBizType }}</div>
          <div>{{ $t('fms_pay_refund.she_bei_zhuang_tai') }}：{{ getDicValue('order_device_biz_state', scope.row.bizState) }}</div>
          <div>{{ $t('fms_pay_refund.zu_lin_shi_chang') }}：{{ scope.row.rentalTerm }}{{ getDicValue('rental_term_unit', scope.row.rentalTermUnit) }}</div>
          <div>{{ $t('fms_pay_refund.zu_jin') }}：{{ scope.row.unitPrice }}/{{ getDicValue('rental_term_unit', scope.row.rentalTermUnit) }}</div>
          <div>{{ $t('fms_pay_refund.shou_hou_fu_jia_fei') }}：{{ scope.row.additionalFee || '-' }}/{{ getDicValue('rental_term_unit', scope.row.rentalTermUnit) }}</div>
          <div>{{ $t('fms_pay_refund.wei_yue_jin') }}：{{ scope.row.receivableBreak }}</div>
          <div>{{ $t('fms_pay_refund.zhi_fu_fang_shi') }}：{{ getDicValue('crm_payment_period', scope.row.paymentPeriod) }}</div>
          <div>{{ $t('fms_pay_refund.fu_kuan_jie_dian') }}：{{ getDicValue('payment_node', scope.row.paymentNode) }}</div>
          <div>{{ $t('fms_pay_refund.qi_zu_ri_qi') }}：{{ momentAmPm($momentLocal(scope.row.rentalStartTime)) }}</div>
          <div>{{ $t('fms_pay_refund.dao_qi_ri_qi') }}：{{ $momentLocal(scope.row.endRentDate, 'YYYY-MM-DD') }}</div>
        </template>
        <template
          slot="action"
          slot-scope="scope"
        >
          <span></span>
          <div v-if="funcView.pay_refund_refund_register && [0, 1].includes(scope.row.billTradeState)">
            <!-- 退款登记 -->
            <el-button
              type="text"
              size="mini"
              @click="onRefundRecord(scope.row)"
            >{{ funcView.pay_refund_refund_register }}</el-button>
          </div>
          <div v-if="funcView.pay_refund_check_refund_msg && [10].includes(scope.row.billTradeState)">
            <!-- 查看退款信息 -->
            <el-button
              type="text"
              size="mini"
              @click="watchRefundRecord(scope.row)"
            >{{ funcView.pay_refund_check_refund_msg }}</el-button>
          </div>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <!-- 退款登记/查看退款信息 -->
    <refund-record-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="onSuccess"
      :isReverse="true"
      type="pay"
    ></refund-record-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import commonMixin from '@/pages/fms/mixins/commonMixin';
import refundRecordDialog from './children/refund_register_dialog.vue';

const isMock = false;

export default {
  name: 'payRefund',
  mixins: [commonMixin],
  components: { refundRecordDialog },
  data() {
    return {
      tableSelect: [],
      formSearch: {
        // 交易状态 bill_trade_state
        billTradeState: [],
        // 合同编号
        contractNo: '',
        // 机身号
        bodyNum: '',
        // 收款日期 beginOfPaymentTime endOfPaymentTime
        dateTime1: '',
        // 退款日期区间 beginOfFinalPaymentTime  endOfFinalPaymentTime
        dateTime2: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1
      },
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
      dialogVisible2: false,
      dialogModel2: {},
      link: null
    };
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableList();
    this.getFuncView('/pay/refund', () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
  },
  methods: {
    getReqData() {
      const reqData = {
        ...this.formSearch
      };
      const dateTime1 = this.formSearch.dateTime1;
      const dateTime2 = this.formSearch.dateTime2;
      if (dateTime1 && dateTime1.length) {
        reqData.beginOfPaymentTime = dateTime1[0];
        reqData.endOfPaymentTime = dateTime1[1];
      }
      if (dateTime2 && dateTime2.length) {
        reqData.beginOfFinalPaymentTime = dateTime2[0];
        reqData.endOfFinalPaymentTime = dateTime2[1];
      }
      delete reqData.dateTime1;
      delete reqData.dateTime2;

      return this.appendReqListData(reqData, 'pay_refund');
    },
    // 获取表格数据
    getTableList: function () {
      const reqData = this.getReqData();

      this.$getJSON(apis.billRefundRent, this.appendReqListData(reqData, 'pay_refund')).then((res) => {
        this.tableList = this.formatList(res.data.list);
        this.totalRows = res.data.total;
      });
    },
    formatList(list) {
      list.forEach((item) => {
        if (isMock) {
          item.billId = '';
          item.refundId = '';
          item.paymentCode = '';
        }
      });
      return list;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    onSuccess() {
      this.onPageChange({ page: 1 });
      this.dialogVisible = false;
    },
    // 退款登记 显示条件：billId
    onRefundRecord: function (row) {
      const { billId } = row;
      if (!billId) {
        this.$message.error(
          this.$t('fms_pay_refund.sjycqsgjzd')
        );
        return;
      }
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('fms_pay_refund.tui_kuan_deng_ji');
      this.dialogModel.row = row;
      this.dialogVisible = true;
    },
    // 查看退款信息 显示条件：billId
    watchRefundRecord: function (row) {
      const { billId } = row;
      if (!billId) {
        this.$message.error(
          this.$t('fms_pay_refund.sjycqsgjzd')
        );
        return;
      }
      this.dialogModel.type = 'watch';
      this.dialogModel.title = this.$t('fms_pay_refund.cktkxx');
      this.dialogModel.row = row;
      this.dialogVisible = true;
    },
    // 清空
    clearFilter: function () {
      this.$refs.table.clearFilter();
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    }
  }
};
</script>

<style lang="scss"></style>
